import Axios from 'axios';

export default {
  getDashboardConvenioMarco(params = {}) {
    // Construir query string dinámicamente
    const queryParams = new URLSearchParams();
    
    if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);
    if (params.regionCodigo) queryParams.append('regionCodigo', params.regionCodigo);
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `DashboardCM/GetDashboardConvenioMarco?${queryString}` : 'DashboardCM/GetDashboardConvenioMarco';
    
    return Axios.get(endpoint);
  },

  getRegionesDisponibles() {
    return Axios.get('DashboardCM/GetRegionesDisponibles');
  },

  getDetalleConvenioMarco(tipo, filtro, params = {}) {
    const queryParams = new URLSearchParams();
    
    queryParams.append('tipo', tipo);
    queryParams.append('filtro', filtro);
    if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);
    
    const queryString = queryParams.toString();
    const endpoint = `DashboardCM/GetDetalleConvenioMarco?${queryString}`;
    
    return Axios.get(endpoint);
  },

  async exportarDashboardExcel(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);
    if (params.regionCodigo) queryParams.append('regionCodigo', params.regionCodigo);
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `DashboardCM/ExportarDashboardExcel?${queryString}` : 'DashboardCM/ExportarDashboardExcel';

    const response = await Axios({
      url: endpoint,
      method: 'GET',
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    // Nombre del archivo basado en filtros
    const fechaStr = params.fechaInicio ? `_${params.fechaInicio}_${params.fechaFin || params.fechaInicio}` : '';
    const regionStr = params.regionCodigo ? `_${params.regionCodigo}` : '';
    
    link.setAttribute('download', `DashboardCM${fechaStr}${regionStr}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}